export default __webpack_public_path__ + "static/media/commingSoon.434fe77f.jpg";